import { Action } from '@anm/components/ActionsDropdown';
import { DropdownWrapper } from '@anm/components/Dropdown';
import Button, { ButtonProps } from '@anm/components/buttons/Button';
import IconButton from '@anm/components/buttons/IconButton/Wrapper';
import { FC } from 'react';
import styled from 'styled-components';

import { PlayerBlockProps } from '../..';

export type ActionsBlockProps = Pick<PlayerBlockProps, 'actions'> & {
  closeModal: () => void;
};

const Wrapper = styled.div`
  margin-top: 45px;
  display: flex;
  > * {
    margin-right: 10px;
  }
  > :last-child {
    margin-right: 0;
  }
  ${DropdownWrapper} {
    width: 50px;
    height: 50px;
  }
`;

const LocalButton: FC<Action> = ({ name, icon, renderLink, handler }) => {
  if (!name || !(renderLink || handler)) return null;

  const render = renderLink || (((children: JSX.Element) => children) as FC);

  const buttonProps: ButtonProps = {
    size: 'upper-medium',
    variant: 'gray-system',
    onClick: handler
  };

  return render(
    <>
      {icon ? (
        <IconButton icon={icon} {...buttonProps}>
          {name}
        </IconButton>
      ) : (
        <Button {...buttonProps}>{name}</Button>
      )}
    </>
  );
};
const ActionsBlock: FC<ActionsBlockProps> = ({ actions, closeModal }) => {
  const { mainAction, secondAction, thirdAction } = actions.reduce(
    (acc, action) => {
      switch (action.name) {
        case 'Edit image':
        case 'Edit video': {
          acc.mainAction = {
            ...action,
            handler: () => {
              action.handler?.();
              closeModal();
            }
          };
          break;
        }
        case 'Embed': {
          acc.secondAction = action;
          break;
        }
        case 'Player': {
          acc.thirdAction = { ...action, name: 'More...', icon: '' };
          break;
        }

        default: {
          acc.dropdownActions.push(action);
        }
      }

      return acc;
    },
    { dropdownActions: [] as Action[], mainAction: {} as Action, secondAction: {} as Action, thirdAction: {} as Action }
  );

  return (
    <Wrapper>
      <LocalButton {...mainAction} />
      <LocalButton {...secondAction} />
      <LocalButton {...thirdAction} />
    </Wrapper>
  );
};

export default ActionsBlock;
